<template>
  <div ref="map" :style="{'paddingTop': computedAspectRatio + '%'}"></div>
</template>

<script>
  import {
    Loader
  } from "@googlemaps/js-api-loader"

  import mapStyles from './imports/mapStyles.json'

  const loader = new Loader({
    apiKey: process.env.NODE_ENV === 'development' ? process.env.MIX_MAP_KEY_LOCAL : process.env.MIX_MAP_KEY,
    version: "weekly",
    // ...additionalOptions,
  });

  export default {
    props: {
      aspectRatio: {
        type: Object,
        required: false,
        default: () => {
          return {
            "1200": 40,
            "992": 60,
            "576": 80,
            "0": 100
          }
        }
      },
      center: {
        type: Array,
        required: false,
        default: () => [37.992566, 23.767961]
      },
      zoom: {
        type: Number,
        required: false,
        default: 17
      },
      markers: {
        type: Array,
        required: false,
        default: () => [{
          id: "1",
          position: [37.992566, 23.767961],
          title: `<p class='mb-2'><b>Freshdesign</b></p>`,
          descr: `<p class='lh-15'>Sevastoupoleos 113, <br> Ampelokipoi <br> Athens</p>`
        }]
      }
    },
    computed: {
      compMarkers() {
        if (this.markers) {
          this.markers.forEach((marker) => {
            if (!marker.icon) {
              marker.icon = {
                url: `/public/site/${process.env.MIX_TEMPLATE_FOLDER}/dist/images/pin.png`,
                // size: {width: 46, height: 46, f: 'px', b: 'px'},
                scaledSize: {
                  width: 100,
                  height: 101,
                  f: 'px',
                  b: 'px'
                }
              }
            }
          })
        }

        return this.markers
      },
      computedAspectRatio() {
        let ar = this.aspectRatio['0']

        for (const [key, value] of Object.entries(this.aspectRatio)) {
          let keyInt = parseInt(key)

          if (keyInt <= this.windowWidth) {
            ar = this.aspectRatio[key]
          }
        }

        return ar
      }
    },
    data() {
      return {
        options: {
          // gestureHandling: "greedy",
          scrollwheel: false,
          streetViewControl: false,
          mapTypeControl: false,
          zoomControl: true,
          fullscreenControl: false
        },
        infoWindow: {
          open: false,
          options: {
            pixelOffset: {
              width: 0,
              height: -15
            }
          },
          content: {
            title: `<p class='mb-2'><b>Freshdesign</b></p>`,
            descr: `<p class='lh-15'>Sevastoupoleos 113, <br> Ampelokipoi <br> Athens</p>`,
            tel: '<p>+30 210 62000 18</p>'
          },
          position: null
        },
        // clusterStyles: [{
        //   textColor: '#fff',
        //   url: `/public/site/${process.env.MIX_TEMPLATE_FOLDER}/dist/images/cluster.png`,
        //   height: 50,
        //   width: 50
        // }],
        currentMidx: null,
        windowWidth: window.innerWidth,
      }
    },
    methods: {
      // toggleInfoWindow: function (position, content, idx) {

      //   let infowindow = new google.maps.InfoWindow({
      //     content: 'sfdas'
      //   })

      //   infowindow.open(map, googleMarker)

      //   this.infoWindow.position = position;
      //   this.infoWindow.content = content;

      //   //check if its the same marker that was selected if yes toggle
      //   if (this.currentMidx == idx) {
      //     this.infoWindow.open = !this.infoWindow.open;
      //   }

      //   //if different marker set infowindow to open and reset current marker index
      //   else {
      //     this.infoWindow.open = true;
      //     this.currentMidx = idx;
      //   }
      // }
      onResize() {
        this.windowWidth = window.innerWidth
      }
    },
    created() {
      window.addEventListener("resize", this.onResize, {
        passive: false
      })
    },
    mounted() {
      loader.load().then(() => {
        const map = new google.maps.Map(this.$refs['map'], {
          center: {
            lat: this.center[0],
            lng: this.center[1]
          },
          zoom: this.zoom,
          styles: mapStyles,
          options: this.options
        })

        this.compMarkers.map((marker, i) => {
          const googleMarker = new google.maps.Marker({
            position: {
              lat: marker.position[0],
              lng: marker.position[1]
            },
            icon: marker.icon,
            map: map,
            // label: labels[i % labels.length],
          })

          const infowindow = new google.maps.InfoWindow({
            content: marker.title + marker.descr
          })

          googleMarker.addListener("click", () => {
            infowindow.open(map, googleMarker)
          })
        })
      })
    },
    destroyed() {
      window.removeEventListener("resize", this.onResize)
    }
  }
</script>

<style lang="scss">
  .gm-style-iw-d {
    &>div {
      padding: 10px 10px;
    }
  }
</style>